<template>
  <v-card elevation="3">
    <v-toolbar
      flat
      color="primary"
      dark
    >
      <v-toolbar-title>Delivery information for Alco agency code: {{ id }}</v-toolbar-title>
    </v-toolbar>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    id: {
      type: String,
      required: true,
    },
  }
});
</script>
